<template>
<div>
<!--    &lt;!&ndash; Loader Start &ndash;&gt;-->
<!--    <div class="fullpage-loader">-->
<!--        <span></span>-->
<!--        <span></span>-->
<!--        <span></span>-->
<!--        <span></span>-->
<!--        <span></span>-->
<!--        <span></span>-->
<!--    </div>-->
<!--    &lt;!&ndash; Loader End &ndash;&gt;-->

    <!-- Header Start -->
    <header class="header-2">
        <div class="top-nav top-header sticky-header sticky-header-3">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="navbar-top">
                            <button class="navbar-toggler d-xl-none d-block p-0 me-3" type="button"
                                    data-bs-toggle="offcanvas" data-bs-target="#primaryMenu">
                                <span class="navbar-toggler-icon">
                                    <i class="iconly-Category icli theme-color"></i>
                                </span>
                            </button>


                            <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" class="web-logo nav-logo">
                                <img :src="main?.settings?.logo" class="img-fluid blur-up lazyload" v-if="main?.settings?.logo" :alt="main?.settings?.name">
                            </router-link>

                            <div class="search-full">
                                <div class="input-group">
                                    <span class="input-group-text">
                                        <i data-feather="search" class="font-light"></i>
                                    </span>
                                    <input type="text" class="form-control search-type" placeholder="Search here..">
                                    <span class="input-group-text close-search">
                                        <i data-feather="x" class="font-light"></i>
                                    </span>
                                </div>
                            </div>

                            <div class="middle-box">
                                <div class="center-box">
                                    <div class="searchbar-box order-xl-1 d-none d-xl-block">
                                        <form :action="`/${this.$i18n.locale}/products`" method="get">
                                            <input type="search" name="name" class="form-control" id="exampleFormControlInput1"
                                                   :placeholder="$t('input_search')">
                                            <button class="btn search-button">
                                                <i class="iconly-Search icli"></i>
                                            </button>
                                        </form>
                                    </div>
                                    <div class="location-box-2">
                                        <button class="btn location-button" type="submit" data-bs-toggle="modal"
                                                data-bs-target="#locationModal">
                                            <i class="iconly-Location icli"></i>
<!--                                            <span class="locat-name">{{ $t('Riyadh') }}</span>-->
                                            <span class="locat-name">{{ $t('Orders are currently within the Riyadh region only') }}</span>
<!--                                            <i class="fa-solid fa-angle-down down-arrow"></i>-->
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="rightside-box">
                                <div class="search-full">
                                    <div class="input-group">
                                        <span class="input-group-text">
                                            <i data-feather="search" class="font-light"></i>
                                        </span>
                                        <input type="text" class="form-control search-type" placeholder="Search here..">
                                        <span class="input-group-text close-search">
                                            <i data-feather="x" class="font-light"></i>
                                        </span>
                                    </div>
                                </div>
                                <ul class="right-side-menu">
                                    <li class="right-side">
                                        <div class="delivery-login-box">
                                            <div class="delivery-icon">
                                                <div class="search-box">
                                                    <i data-feather="search"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
<!--                                    -->
<!--                                    <li class="right-side">-->
<!--                                        <a href="wishlist.html" class="btn p-0 position-relative header-wishlist">-->
<!--                                            <i data-feather="heart"></i>-->
<!--                                        </a>-->
<!--                                    </li>-->

                                    <cart-list></cart-list>
                                    <user-cp></user-cp>


                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid-lg">
            <div class="row">
                <div class="col-12">
                    <div class="main-nav">

                        <div class="main-nav navbar navbar-expand-xl navbar-light navbar-sticky">
                            <div class="offcanvas offcanvas-collapse order-xl-2" id="primaryMenu">
                                <div class="offcanvas-header navbar-shadow">
                                    <h5>Menu</h5>
                                    <button class="btn-close lead" type="button" onclick="$('#primaryMenu').offcanvas('hide')"
                                            aria-label="Close"></button>
                                </div>
                                <div class="offcanvas-body">
                                    <ul class="navbar-nav">
                                        <li class="nav-item dropdown"  v-if="main?.occasions?.length > 0 ">
                                            <a class="nav-link dropdown-toggle have-arrow" href="javascript:void(0)"
                                               data-bs-toggle="dropdown">
                                                {{ $t('Gifts according to the occasion') }}
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li v-for="occasion in main?.occasions">

                                                    <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }
                                                    , query: {  'occasion_ids[]': occasion.id  } }"
                                                                 @click="scrollToTop" class="dropdown-item" onclick="$('#primaryMenu').offcanvas('hide')">
                                                         - {{ occasion?.name}}
                                                    </router-link>

                                                </li>
                                            </ul>
                                        </li>

                                        <li class="nav-item dropdown">
                                            <a class="nav-link dropdown-toggle have-arrow" href="javascript:void(0)"
                                               data-bs-toggle="dropdown">
                                                {{ $t('Gifts by section') }}
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li v-for="section in main?.sections">

                                                    <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }
                                                    , query: {  'section_ids[]': section.id } }"
                                                                 @click="scrollToTop" class="dropdown-item" onclick="$('#primaryMenu').offcanvas('hide')">
                                                      - {{ section?.name}}
                                                    </router-link>

                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item dropdown">
                                            <a class="nav-link dropdown-toggle have-arrow" href="javascript:void(0)"
                                               data-bs-toggle="dropdown">
                                                {{ $t('Gifts by category') }}
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li v-for="category in main?.categories">

                                                    <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }
                                                    , query: {  'category_ids[]': category.id ,   } }"
                                                                 @click="scrollToTop" class="dropdown-item" onclick="$('#primaryMenu').offcanvas('hide')">
                                                      - {{ category?.name}}
                                                    </router-link>

                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item dropdown">
                                            <a class="nav-link dropdown-toggle have-arrow" href="javascript:void(0)"
                                               data-bs-toggle="dropdown">
                                                {{ $t('Gifts by stores') }}
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li v-for="vendor in main?.vendors">

                                                    <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }
                                                    , query: {  'vendor_ids[]': vendor.id ,   } }"
                                                                 @click="scrollToTop" class="dropdown-item" onclick="$('#primaryMenu').offcanvas('hide')">
                                                        - {{ vendor?.name}}
                                                    </router-link>
                                                </li>
                                                <li v-if="main?.vendors?.length == 10">

                                                    <router-link :to="{name: 'products.index', params: { lang : $i18n.locale } }"
                                                                 @click="scrollToTop" class="dropdown-item" onclick="$('#primaryMenu').offcanvas('hide')">
                                                        - {{ $t('More')}}
                                                    </router-link>
                                                </li>

                                            </ul>
                                        </li>

<!--                                        <li v-for="page in main?.pages" class="nav-item dropdown">-->
<!--                                            <router-link :to="{name: 'pages.show', params: { id: page.id , lang : $i18n.locale }}"-->
<!--                                                         @click="scrollToTop" class="nav-link " onclick="$('#primaryMenu').offcanvas('hide')">{{ page.title }}</router-link>-->
<!--                                        </li>-->


                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="right-nav">
                            <template  v-for="data in main?.contact_data">

                                <div class="nav-number" v-if="data?.type == 'phone'" >
                                    <img src="/theme/assets/images/icon/music.png" class="img-fluid blur-up lazyload" alt="">
                                    <span style="direction: ltr;">{{ data?.value }}</span>
                                </div>
                                <a  v-if="data?.type == 'phone'" :href="data?.href" class="btn theme-bg-color ms-3 fire-button" data-bs-toggle="modal" data-bs-target="#deal-box">
                                    <div class="fire">
                                        <img src="/theme/assets/images/icon/hot-sale.png" class="img-fluid" alt="">
                                    </div>
                                    <span>{{ $t('customers support') }}</span>
                                </a>
                            </template>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </header>
    <!-- Header End -->

    <section class="search-section d-block d-md-none  mb-3">
        <div class="container-fluid-lg">
            <div class="row">
                <div class="col-xxl-6 col-xl-8 mx-auto">
<!--                    <div class="title d-block text-center">-->
<!--                        <h2>Search for products</h2>-->
<!--                        <span class="title-leaf">-->
<!--                            <svg class="icon-width">-->
<!--                                <use xlink:href="../assets/svg/leaf.svg#leaf"></use>-->
<!--                            </svg>-->
<!--                        </span>-->
<!--                    </div>-->


                    <form :action="`/${this.$i18n.locale}/products`" method="get">
                        <div class="search-box">
                            <div class="input-group">

                                <input type="search" name="name" class="form-control" id="exampleFormControlInput1"
                                       :placeholder="$t('input_search')">

                                <button class="btn theme-bg-color text-white m-0" type="submit" id="button-addon1">
                                    {{  $t('Search') }}</button>
                            </div>
                        </div>
                    </form>


                </div>
            </div>
        </div>
    </section>


    <main>
<!--        <router-view :main="main"-->
<!--                     :key="$route.path ?? $route.url"-->
<!--        ></router-view>-->
        <router-view :main="main"
                     :key="$route.fullPath"
        ></router-view>
    </main>

    <!-- Footer Start -->
    <footer class="section-t-space footer-section-2">
        <div class="container-fluid-lg">
            <div class="main-footer">
                <div class="row g-md-4 gy-sm-5 gy-2">
                    <div class="col-xxl-3 col-xl-4 col-sm-6">

                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" class="foot-logo">
                            <img :src="main?.settings?.logo"  class="img-fluid" alt="">
                        </router-link>

                        <p class="information-text">
                            {{ $t('about') }}
                        </p>
                        <ul class="social-icon">

                            <li v-for="social_item in main?.social">
                                <a :href="social_item.url" target="_blank">
                                    <i :class="'fa-brands fa-' + social_item.icon"></i>
                                </a>
                            </li>

                        </ul>

                        <div class="social-app mt-sm-4 mt-3 mb-4" v-if="main?.settings?.app_store_url && main?.settings?.google_play_url ">
                            <ul>
                                <li>
                                    <a :href="main?.settings?.google_play_url" target="_blank">
                                        <img src="/theme/assets/images/playstore.svg" class="blur-up lazyload" alt="">
                                    </a>
                                </li>
                                <li>
                                    <a :href="main?.settings?.app_store_url" target="_blank">
                                        <img src="/theme/assets/images/appstore.svg" class="blur-up lazyload" alt="">
                                    </a>
                                </li>
                            </ul>
                        </div>

                    </div>

                    <div class="col-xxl-2 col-xl-4 col-sm-6">
                        <div class="footer-title">
                            <h4>{{ $t('Events sections') }}</h4>
                        </div>
                        <ul class="footer-list footer-contact mb-sm-0 mb-3">
                            <li  v-for="occasion in main?.occasions">

                                <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }  , query: {  'occasion_ids[]': occasion.id } }"
                                             @click="scrollToTop" class="footer-contain-2">

                                    <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}"></i>

                                    {{ occasion?.name}}
                                </router-link>

                            </li>
                        </ul>
                    </div>

                    <div class="col-xxl-2 col-xl-4 col-sm-6">
                        <div class="footer-title">
                            <h4>{{ $t('Gift sections') }}</h4>
                        </div>
                        <ul class="footer-list footer-contact mb-sm-0 mb-3">
                            <li  v-for="category in main?.categories">

                                <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }  , query: {  'category_ids[]': category.id } }"
                                             @click="scrollToTop" class="footer-contain-2">
                                    <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}"></i> {{ category?.name}}
                                </router-link>

                            </li>
                        </ul>
                    </div>
                    <div class="col-xxl-2 col-xl-4 col-sm-6">
                        <div class="footer-title">
                            <h4>{{ $t('Important links')}}</h4>
                        </div>
                        <ul class="footer-list footer-contact mb-sm-0 mb-3">

                            <li  v-for="page in main?.pages">
                                <router-link :to="{name: 'pages.show', params: { id: page.id , lang : $i18n.locale }}"  @click="scrollToTop" class="footer-contain-2">
                                    <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}"></i>
                                    {{ page.title }}
                                </router-link>
                            </li>

                            <li  >
                                <router-link :to="{name: 'faqs.index' , params: {  lang : $i18n.locale }}" @click="scrollToTop" class="footer-contain-2">
                                    <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}"></i>
                                    {{ $t('common questions')}}
                                </router-link>
                            </li>

                            <li >
                                <router-link :to="{name: 'contact_us.create' , params: { lang : $i18n.locale }}" @click="scrollToTop" class="footer-contain-2">
                                    <i :class="{'fas' : true , 'fa-angle-right' : $i18n.locale === 'en' ,'fa-angle-left' : $i18n.locale === 'ar' ,}"></i>
                                    {{ $t('Contact us')}}
                                </router-link>
                            </li>

                        </ul>
                    </div>

                    <div class="col-xxl-3 col-xl-4 col-sm-6">
                        <div class="footer-title">
                            <h4>{{ $t('contact information')}}</h4>
                        </div>
                        <ul class="footer-address footer-contact">
                            <li v-for="data in main?.contact_data">
                                <a :href="data?.href" >
                                    <div class="inform-box flex-start-box">
                                        <i :class="'  me-2 text-muted ' + data.icon"></i>
                                        <p>{{ data?.value }}</p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="sub-footer section-small-space">
                <div class="left-footer">
                    <p>{{ $t('all rights are save') }} 2023.</p>
                </div>
                <div class="right-footer text-muted">
                        <li>
                            <img src="/theme/assets/images/more/telr.png" alt="طرق الدفع" height="35">
                        </li>
                    <ul class="payment-box">
                        <li class="pt-2">
                            <a href="https://imockup.net/" target="_blank" class=" text-muted">
                                {{ $t('Designed by') }} imockup.net
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    <!-- Footer End -->


    <!-- Tap to top start -->
    <div class="theme-option">
        <div class="back-to-top">
            <a id="back-to-top" href="#">
                <i class="fas fa-chevron-up"></i>
            </a>
        </div>
    </div>
    <!-- Tap to top end -->

    <!-- Bg overlay Start -->
    <div class="bg-overlay"></div>
    <!-- Bg overlay End -->


    <!-- mobile fix menu start -->
    <div class="mobile-menu d-md-none d-block mobile-cart">
        <ul>
            <li class="active">
                <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                    <i class="iconly-Home icli"></i>
                    <span>{{ $t('Home') }}</span>
                </router-link>
            </li>

            <li class="mobile-category">
                <a type="button"
                        data-bs-toggle="offcanvas" data-bs-target="#primaryMenu">

                    <i class="iconly-Category icli js-link"></i>
                    <span>{{ $t('Menu') }}</span>
                </a>
            </li>

            <li>
                <router-link :to="{name: ! auth.isLoggedIn() ? 'login' :'cart_items.index', params: { lang : $i18n.locale  }}">
                    <i class="iconly-Bag-2 icli fly-cate"></i>
                    <span>{{ $t('Cart')}}</span>
                </router-link>
            </li>
        </ul>
    </div>
    <!-- mobile fix menu end -->

</div>
</template>

<script>

import CartList from "./components/cart_item/CartList.vue";
import UserCp from "./components/auth/user-cp.vue";

export default {
    name: "app",
    components: {
        CartList,
        UserCp
    },
    inject: ['auth'],
    data() {
        return {
            // currentLocale: '',
            main: [],
        }
    },
    async created() {
        await this.getMain();


    },
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
        async getMain() {
            await axios.get('main').then(response => {
                // toast.success("content loading...", {
                //     timeout: 2000
                // });
                this.main = response.data?.data;
                // this.currentLocale = response.data?.data?.lang;
                // this.$i18n.locale = this.currentLocale;
                // console.log(this.currentLocale);

            });
        },
    },
}
</script>
